<template>
  <section>
    <v-layout row wrap class="mt-5">
      <v-flex xs10 offset-xs1>
        <v-layout row wrap>
          <v-flex xs4 class="px-2 py-2">
            <router-link  :to="'showInstitutions'" class="enlace">
              <v-card flat color="light-blue lighten-1" class="white--text py-4 bordes" >
                <v-container fluid grid-list-lg>
                  <v-layout row>
                    <v-flex xs3>
                       <v-layout column align-center justify-center>
                          <v-layout justify-space-around class="circulo">
                            <v-icon x-large  color="light-blue lighten-1">business</v-icon>
                          </v-layout>
                        </v-layout>
                    </v-flex>
                    <v-flex xs7>
                      <div>
                        <div class="headline white--text">Instituciones</div>
                      </div>
                    </v-flex>
                    <v-flex xs2>

                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card>
            </router-link>
          </v-flex>
<!-- 
          <v-flex xs4 class="px-2 py-2">
            <router-link  :to="'showFaculties'" class="enlace">
              <v-card flat color="blue-grey lighten-1" class="white--text py-4 bordes" >
                <v-container fluid grid-list-lg>
                  <v-layout row>
                    <v-flex xs3>
                       <v-layout column align-center justify-center>
                          <v-layout justify-space-around class="circulo">
                            <v-icon x-large  color="blue-grey lighten-1">store</v-icon>
                          </v-layout>
                        </v-layout>
                    </v-flex>
                    <v-flex xs7>
                      <div>
                        <div class="headline white--text">Facultades</div>
                      </div>
                    </v-flex>
                    <v-flex xs2>
 
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card>
            </router-link>
          </v-flex>

          <v-flex xs4 class="px-2 py-2">
            <router-link  :to="'showCarreras'" class="enlace">
              <v-card flat color="teal accent-3" class="white--text py-4 bordes" >
                <v-container fluid grid-list-lg>
                  <v-layout row>
                    <v-flex xs3>
                       <v-layout column align-center justify-center>
                          <v-layout justify-space-around class="circulo">
                            <v-icon x-large  color="teal accent-3">school</v-icon>
                          </v-layout>
                        </v-layout>
                    </v-flex>
                    <v-flex xs7>
                      <div>
                        <div class="headline white--text">Carreras</div>
                      </div>
                    </v-flex>
                    <v-flex xs2>

                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card>
            </router-link>
          </v-flex>

          <v-flex xs4 class="px-2 py-2">
            <router-link  :to="'newLicence'" class="enlace">
              <v-card flat color="deep-orange lighten-1" class="white--text py-4 bordes" >
                <v-container fluid grid-list-lg>
                  <v-layout row>
                    <v-flex xs3>
                       <v-layout column align-center justify-center>
                          <v-layout justify-space-around class="circulo">
                            <v-icon x-large  color="deep-orange lighten-1">card_membership</v-icon>
                          </v-layout>
                        </v-layout>
                    </v-flex>
                    <v-flex xs7>
                      <div>
                        <div class="headline white--text">Licencias</div>
                      </div>
                    </v-flex>
                    <v-flex xs2>

                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card>
            </router-link>
          </v-flex>


          <v-flex xs4 class="px-2 py-2">
            <router-link  :to="'showCategory'" class="enlace">
              <v-card flat color="amber darken-3" class="white--text py-4 bordes" >
                <v-container fluid grid-list-lg>
                  <v-layout row>
                    <v-flex xs3>
                       <v-layout column align-center justify-center>
                          <v-layout justify-space-around class="circulo">
                            <v-icon x-large  color="amber darken-3">category</v-icon>
                          </v-layout>
                        </v-layout>
                    </v-flex>
                    <v-flex xs7>
                      <div>
                        <div class="headline white--text">Categorías</div>
                      </div>
                    </v-flex>
                    <v-flex xs2>

                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card>
            </router-link>
          </v-flex>
          <v-flex xs4 class="px-2 py-2">
            <router-link  :to="'showGalleries'" class="enlace">
              <v-card flat color="deep-purple lighten-1" class="white--text py-4 bordes" >
                <v-container fluid grid-list-lg>
                  <v-layout row>
                    <v-flex xs3>
                       <v-layout column align-center justify-center>
                          <v-layout justify-space-around class="circulo">
                            <v-icon x-large  color="deep-purple lighten-1">add_photo_alternate</v-icon>
                          </v-layout>
                        </v-layout>
                    </v-flex>
                    <v-flex xs7>
                      <div>
                        <div class="headline white--text">Imagenes curso</div>
                      </div>
                    </v-flex>
                    <v-flex xs2>

                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card>
            </router-link>
          </v-flex>



          <v-flex xs4 class="px-2 py-2">
            <router-link  :to="'typeCompetences'" class="enlace">
              <v-card flat color="teal darken-1" class="white--text py-4 bordes" >
                <v-container fluid grid-list-lg>
                  <v-layout row>
                    <v-flex xs3>
                       <v-layout column align-center justify-center>
                          <v-layout justify-space-around class="circulo">
                            <v-icon x-large  color="lime lighten-1">merge_type</v-icon>
                          </v-layout>
                        </v-layout>
                    </v-flex>
                    <v-flex xs7>
                      <div>
                        <div class="headline white--text">Tipo de Competencias</div>
                      </div>
                    </v-flex>
                    <v-flex xs2>

                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card>
            </router-link>
          </v-flex>

          <v-flex xs4 class="px-2 py-2">
            <router-link  :to="'maintainerEvaluation'" class="enlace">
              <v-card flat color="lime lighten-1" class="white--text py-4 bordes" >
                <v-container fluid grid-list-lg>
                  <v-layout row>
                    <v-flex xs3>
                       <v-layout column align-center justify-center>
                          <v-layout justify-space-around class="circulo">
                            <v-icon x-large  color="lime lighten-1">merge_type</v-icon>
                          </v-layout>
                        </v-layout>
                    </v-flex>
                    <v-flex xs7>
                      <div>
                        <div class="headline white--text">Tipo de Evaluación</div>
                      </div>
                    </v-flex>
                    <v-flex xs2>

                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card>
            </router-link>
          </v-flex>

           <v-flex xs4 class="px-2 py-2">
            <router-link  :to="'getAllUsuario'" class="enlace">
              <v-card flat color="lime lighten-1" class="white--text py-4 bordes" >
                <v-container fluid grid-list-lg>
                  <v-layout row>
                    <v-flex xs3>
                       <v-layout column align-center justify-center>
                          <v-layout justify-space-around class="circulo">
                            <v-icon x-large  color="lime lighten-1">person</v-icon>
                          </v-layout>
                        </v-layout>
                    </v-flex>
                    <v-flex xs7>
                      <div>
                        <div class="headline white--text">Usuarios</div>
                      </div>
                    </v-flex>
                    <v-flex xs2>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card>
            </router-link>
          </v-flex>  -->

        </v-layout>
      </v-flex>
    </v-layout>

    <v-layout row wrap class="mt-5">
      <v-flex xs10 offset-xs1>
        <v-layout row wrap>
          
        </v-layout>
      </v-flex>
    </v-layout>


  </section>
</template>

<script>

export default {
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style scoped>
.circulo {
     width: 60px;
     height: 60px;
     -moz-border-radius: 50%;
     -webkit-border-radius: 50%;
     border-radius: 50%;
     background: white;
}

.bordes {
  border-radius: 20px 20px 20px 20px;
-moz-border-radius: 20px 20px 20px 20px;
-webkit-border-radius: 20px 20px 20px 20px;
border: 0px solid #000000;
}
.enlace {
  text-decoration:none;
}
</style>


// WEBPACK FOOTER //
// src/components/Administrador/Maintainer.vue